import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import * as fromCoursePlayer from '../course-player.reducer';
import * as actions from '../course-player.actions';

@Component({
  selector: 'app-content-section',
  templateUrl: './content-section.component.html'
})
export class ContentSectionComponent implements OnInit {

  @Input()
  zoomWidth!: number

  coursePlayerState$: Observable<any>
  coursePlayerStateSubscription: Subscription;

  constructor(private store: Store<{ coursePlayerState: fromCoursePlayer.State }>) { 
    
    this.coursePlayerState$ = this.store.select(fromCoursePlayer.getCoursePlayerState);
  }

  ngOnInit(): void {
  }

  onPan($event) {

  }

  onTap($event) {   

    console.log("ZOOM", { event: event});

    //if ($event.tapcount == 2) {
      this.store.dispatch(new actions.Zoom() )
    //}
  }

  trackPageId(index: number, page: any) {
    return page.id;
  }

}
